import React from 'react';
import { connect } from 'react-redux';
import Link from 'components/Link';
import makeRequest from 'utils/makeRequest';
import ElementInView from 'components_v2/common/ElementInView/ElementInView';
import Card from '../CardV2/Card';
import s from './CardListRhs.scss';

function fetchData(isMobile, feedUrl, callback) {
  makeRequest
    .get(feedUrl, { isMobile }, 'skipfeedengine')
    .catch(err => console.log(err))
    .then(data => {
      if (
        data &&
        data.status === 200 &&
        data.data &&
        typeof callback === 'function'
      ) {
        callback(data.data);
      }
    });
}

class CardListRhs extends React.Component {
  constructor() {
    super();
    this.state = {
      relatedStories: [],
    };
  }

  componentDidMount() {
    this.fetchRelatedStoriesData();
  }

  fetchRelatedStoriesData = () => {
    const { item, isMobile } = this.props;
    const { id, dataUrl } = item;
    if (id && id === 'related_stories' && dataUrl) {
      fetchData(isMobile, dataUrl, data => {
        if (data && Array.isArray(data) && data.length > 0) {
          this.setState({ relatedStories: data });
        }
      });
    }
  };

  renderStories = (items, itemClass, isPrimeStory, id, isLead = false) =>
    items.map((dataitem, index) => {
      const viewGa =
        dataitem.ag && dataitem.ag === 'spotlight'
          ? `sl_${index + 1}_${dataitem.id || dataitem.imageid}`
          : null;

      dataitem.imageid = dataitem.id || dataitem.msid || dataitem.imageid;
      return (
        <Card
          data={dataitem}
          itemCssClassName={itemClass}
          newga={`Click#RC_RHS-${id}-${dataitem.wu}`}
          key={dataitem.id || `${dataitem.tn}_${isLead ? 0 : index + 1}`}
          isPrimeStory={isPrimeStory}
          viewga={viewGa}
          lazyload
          isLeadPhoto={isLead}
        />
      );
    });

  render() {
    const { data = [], itemClass, isPrimeStory, item } = this.props;

    const { relatedStories } = this.state;

    const { name, link, moreText, id } = item;

    if (
      !(
        (data && Array.isArray(data)) ||
        (relatedStories && Array.isArray(relatedStories))
      )
    ) {
      return null;
    }
    let featured = [];
    if (Array.isArray(relatedStories) && relatedStories.length > 0) {
      featured = [relatedStories[0]];
    } else if (data && Array.isArray(data) && data.length > 0) {
      featured = [data[0]];
    }

    let nonFeatured = [];
    if (Array.isArray(relatedStories) && relatedStories.length > 1) {
      nonFeatured = relatedStories.slice(1);
    } else if (data && Array.isArray(data) && data.length > 1) {
      nonFeatured = data.slice(1);
    }
    if (
      nonFeatured &&
      nonFeatured.length === 0 &&
      (featured && featured.length === 0)
    ) {
      return null;
    }
    return (
      <div className={s.storiesrhswidget}>
        <ElementInView gaAction="View" gaLabel={`RC_RHS-${id}`}>
          {name && <h4>{name}</h4>}
        </ElementInView>

        <div className={s.storiesbigimg}>
          {featured instanceof Array &&
            this.renderStories(featured, itemClass, isPrimeStory, id, true)}
        </div>
        <div className={s.storieslistrhs}>
          {nonFeatured instanceof Array &&
            this.renderStories(nonFeatured, itemClass, isPrimeStory, id)}
        </div>
        {link &&
          moreText && (
            <Link href={link} className={s.moreLink}>
              {moreText}
            </Link>
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isMobile: state.isMobile,
});

export default connect(mapStateToProps)(CardListRhs);
